import { getNativePlayerBridge } from './playerApk';

// Call only from an explicit Exit action, after clearing the local session.
// A close request is not proof of closure: callers must retain a safe fallback.
export function requestPlayerAppClose() {
  if (typeof window === 'undefined') return;
  const bridge = getNativePlayerBridge();
  if (typeof bridge?.closeApp === 'function') {
    try { bridge.closeApp(); return; } catch { /* Older/broken bridge: try browser close. */ }
  }
  try { window.close(); } catch { /* Browser policy may refuse to close this tab. */ }
}
